<div class="page has-title">
  <h1>{{ title }}</h1>

  <div class="row">
    <div class="col-md-3">
      <astrobin-migration-nav></astrobin-migration-nav>
    </div>
    <div class="col-md-9">
      <ng-container *ngIf="migrationStrategies !== undefined; else loading">
        <div *ngIf="migrationStrategies.length === 0; else pendingReviewTemplate" class="alert alert-info">
          The review queue is empty.
        </div>
      </ng-container>
    </div>
  </div>
</div>

<ng-template #loading>
  <astrobin-loading-indicator></astrobin-loading-indicator>
</ng-template>

<ng-template #pendingReviewTemplate>
  <ng-container *ngIf="currentUser$ | async as currentUser; else loading">
    <div class="alert alert-warning">
      <p>
        <strong>Warning!</strong> These are migrations created by moderators, and not regular end-user. When you approve
        migrations on this page, they get applied to all users and images that match that particular equipment items.
      </p>
      <p>When a regular end-user create their own migrations, instead, the apply only to their own images.</p>
    </div>
    <table class="table table-striped">
      <caption>
        Migrations to review
      </caption>
      <thead>
        <tr>
          <th scope="col">Legacy item</th>
          <th scope="col">Migration strategy</th>
          <th scope="col"></th>
        </tr>
      </thead>

      <tbody>
        <tr *ngFor="let migrationStrategy of migrationStrategies; let i = index">
          <td>
            <strong>{{ legacyItems[migrationStrategy.pk]?.make }}</strong> {{ legacyItems[migrationStrategy.pk]?.name }}
          </td>
          <td class="with-help-tooltip">
            {{ migrationStrategy.migrationFlag }}
            <span [ngbTooltip]="migrationFlagTooltip(migrationStrategy.migrationFlag)" class="help-tooltip">
              <fa-icon icon="question-circle"></fa-icon>
            </span>
          </td>
          <td>
            <a
              [class.disabled]="(reviewButtonDisabled$(migrationStrategy) | async) === true"
              (click)="reviewItem($event, migrationStrategy.pk)"
              class="btn btn-mini btn-primary btn-review"
            >
              Review
              <fa-icon [icon]="reviewButtonIcon$(migrationStrategy) | async"></fa-icon>
            </a>
          </td>
        </tr>
      </tbody>
    </table>
  </ng-container>
  <!-- currentUser$ -->
</ng-template>
